var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.currentHotelGtmId)?_c('GTMLoader',{key:_vm.gtmKey,attrs:{"gtm-id":_vm.currentHotelGtmId}}):_vm._e(),_vm._v(" "),_c('GTMLoader',{attrs:{"gtm-id":"GTM-W6P52LJV","data-layer-name":"reserveportLayer"}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158a6e02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 